import { render, staticRenderFns } from "./newcompany.vue?vue&type=template&id=21f0f894&scoped=true&"
import script from "./newcompany.vue?vue&type=script&lang=js&"
export * from "./newcompany.vue?vue&type=script&lang=js&"
import style0 from "./newcompany.vue?vue&type=style&index=0&id=21f0f894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0f894",
  null
  
)

export default component.exports